import createDOMPurify from "dompurify";

const DOMPurify = createDOMPurify(window);

export const SafeHTML = ({ html }: { html: string }) => {
  return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
};
